export default "__VITE_ASSET__BiMw_VWf__"